import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PremiumRouteGuard implements CanActivate {
  isPremiumUser = false;
  private isHandlingNavigation = false;

  constructor(private router: Router) {
    const currentUrl = window.location.href;
    if (currentUrl && currentUrl.includes('platform=premium')) {
      this.isPremiumUser = true;
      this.setupPremiumNavigationHandler();
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url;

    if (currentUrl.includes('platform=premium')) {
      this.isPremiumUser = true;
      
      if (!this.isHandlingNavigation) {
        this.setupPremiumNavigationHandler();
      }
    }

    return true;
  }

  private setupPremiumNavigationHandler(): void {
    this.isHandlingNavigation = true;
    
    this.router.events.pipe(
      filter((event:any) => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => {
      if (this.isHandlingNavigation && !event.url.includes('platform=premium')) {
        this.isHandlingNavigation = false;
        
        const separator = event.url.includes('?') ? '&' : '?';
        const newUrl = `${event.url}${separator}platform=premium`;
        
        this.router.navigated = false;
        
        this.router.navigateByUrl(newUrl).then(() => {
          this.isHandlingNavigation = true;
        });
      }
    });
  }
}